import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ThemeProvider } from 'glamorous';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import PageNotFound from '../../common/components/NotFound/PageNotFound';
import EmailValidation from './Views/EmailValidation';

const Entry = ({ match: { path } }) => {
  return (
    <StandardPageTemplate defaultDocTitle="Users | NFIB">
      <ThemeProvider theme={{ pageColor: 'red' }}>
        <Switch>
          <Route exact path={`${path}/validate`} component={EmailValidation} />
          <Route component={PageNotFound} />
        </Switch>
      </ThemeProvider>
    </StandardPageTemplate>
  );
};
export default Entry;



// WEBPACK FOOTER //
// ./src/App/users/index.js